import React from 'react';
import { Box, Image, Text, Flex, Badge } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { Product } from '../types';
import { Star, ShoppingCart } from 'lucide-react';
const PRESET_COLORS = [{
  name: 'Black',
  hex: '#000000'
}, {
  name: 'White',
  hex: '#FFFFFF'
}, {
  name: 'Red',
  hex: '#EF4444'
}, {
  name: 'Blue',
  hex: '#3B82F6'
}, {
  name: 'Navy',
  hex: '#1E3A8A'
}, {
  name: 'Green',
  hex: '#22C55E'
}, {
  name: 'Pink',
  hex: '#EC4899'
}, {
  name: 'Yellow',
  hex: '#EAB308'
}, {
  name: 'Orange',
  hex: '#F97316'
}, {
  name: 'Purple',
  hex: '#8B5CF6'
}, {
  name: 'Brown',
  hex: '#92400E'
}, {
  name: 'Grey',
  hex: '#6B7280'
}, {
  name: 'Beige',
  hex: '#D2B48C'
}, {
  name: 'Maroon',
  hex: '#7F1D1D'
}, {
  name: 'Cream',
  hex: '#FFFDD0'
}, {
  name: 'Sky Blue',
  hex: '#38BDF8'
}, {
  name: 'Teal',
  hex: '#14B8A6'
}, {
  name: 'Coral',
  hex: '#FF6B6B'
}, {
  name: 'Lavender',
  hex: '#C4B5FD'
}, {
  name: 'Olive',
  hex: '#65A30D'
}];
interface ProductCardProps {
  product: Product;
  index?: number;
}
export const ProductCard: React.FC<ProductCardProps> = ({
  product,
  index = 0
}) => {
  const navigate = useNavigate();
  const discountPercent = product.price > 0 ? Math.round((product.price - product.discountPrice) / product.price * 100) : 0;
  return <Box bg="white" borderRadius="16px" overflow="hidden" shadow="sm" borderWidth="1px" borderColor="gray.100" cursor="pointer" onClick={() => navigate(`/product/${product.id}`)} className="card-premium" style={{
    animationDelay: `${index * 0.1}s`
  }} data-id="element-84">
      <Box position="relative" overflow="hidden" data-id="element-85">
        <Image src={product.images[0]} alt={product.title} h="180px" w="full" objectFit="cover" transition="transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)" _hover={{
        transform: 'scale(1.08)'
      }} data-id="element-86" />
        {discountPercent > 0 && <Badge position="absolute" top={2} left={2} bg="red.500" color="white" fontSize="10px" px={2} py={0.5} borderRadius="8px" fontWeight="700" className="animate-pulse-badge" data-id="element-87">
            {discountPercent}% OFF
          </Badge>}
        {product.stock <= 5 && product.stock > 0 && <Badge position="absolute" bottom={2} right={2} bg="orange.500" color="white" fontSize="9px" px={2} py={0.5} borderRadius="6px" data-id="element-88">
            Only {product.stock} left
          </Badge>}
      </Box>

      <Box p={3} data-id="element-89">
        <Text fontSize="13px" fontWeight="600" noOfLines={2} lineHeight="1.4" color="gray.800" mb={1} data-id="element-90">
          {product.title}
        </Text>

        <Flex align="center" mb={1.5} data-id="element-91">
          <Flex align="center" bg="green.50" px={1.5} py={0.5} borderRadius="6px" data-id="element-92">
            <Text fontSize="11px" fontWeight="700" color="green.600" mr={0.5} data-id="element-93">
              {product.rating || '★'}
            </Text>
            <Star size={9} fill="currentColor" color="var(--chakra-colors-green-600)" data-id="element-94" />
          </Flex>
          <Text fontSize="10px" color="gray.400" ml={1.5} data-id="element-95">
            ({product.reviews || 0})
          </Text>
        </Flex>

        <Flex align="baseline" gap={1.5} data-id="element-96">
          <Text fontSize="lg" fontWeight="800" color="gray.900" data-id="element-97">
            ₹{product.discountPrice}
          </Text>
          {product.price > product.discountPrice && <Text fontSize="11px" color="gray.400" textDecoration="line-through" data-id="element-98">
              ₹{product.price}
            </Text>}
        </Flex>

        {product.sizes && product.sizes.length > 0 && <Text fontSize="10px" color="gray.400" mt={1} data-id="element-99">
            {product.sizes.join(' · ')}
          </Text>}

        {product.colors && product.colors.length > 0 && <Flex gap={1} mt={1.5} data-id="element-100">
            {product.colors.slice(0, 5).map((color, idx) => {
          const hexColor = PRESET_COLORS.find(c => c.name.toLowerCase() === color.toLowerCase())?.hex || color.toLowerCase();
          return <Box key={idx} w="14px" h="14px" borderRadius="full" bg={hexColor} borderWidth="1.5px" borderColor="gray.200" title={color} data-id="element-101" />;
        })}
          </Flex>}

        <Flex align="center" mt={2} gap={1} data-id="element-102">
          <Box w="6px" h="6px" borderRadius="full" bg="green.400" data-id="element-103" />
          <Text fontSize="10px" color="green.500" fontWeight="600" data-id="element-104">
            COD · Free Delivery
          </Text>
        </Flex>
      </Box>
    </Box>;
};